import { createBreakPoints } from './helpers';

const labels = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
const breakpoints = ['0px', '20rem', '50rem', '70rem', '80rem', '100rem'];

export const mediaQueries = createBreakPoints(labels, breakpoints);
const cssMediaQueries = createBreakPoints(labels, breakpoints, true);

//USING THIS TO HAVE REM LIKE MANAGMENT OF HEADER-SIZES WHICH OFTEN HAVE A DIFFERENT FONT
const remCalc = function (size) {
  if (isNaN(size)) {
    size = parseInt(size);
  }
  return size / typography.size.replace('px', '') + 'rem';
};

//COLORS VARIABLES
const colors = {
  white: '#FFF',
  black: '#111',
  red: '#E82A2A',
  green: '#69a24c',
  yellow: '#FFCB37',
  font: '#222',
  primary: '#A1B0AB',
  primaryLight: '#A1B0AB',
  primaryDark: '#63847C',
  secondary: '#333',
  secondaryLight: '#333',
  secondaryDark: '#333',
  discount: '#b44e3c',
  link: '#ce3c8a',
  border: '#DDD',
  borderLight: '#F1F1F1',
  borderDark: '#333',
  borderInput: '#AAA',
  lightgrey: '#f6f6f6',
  vanillaWhite: '#fbf8f4',
  grey: '#565558',
  error: '#ff3131',
  success: '#69a24c',
  greys: [
    '#F9F9F9',
    '#F1F1F1',
    '#D5D5D5',
    '#C4C4C4',
    '#9A9A9A',
    '#777777',
    '#3B3B3B',
  ],
};
colors.buy = colors.primaryDark;
colors.backgroundLight = '#D8DAD9';
colors.backgroundDark = colors.primaryDark;
colors.inStock = '#339600';
colors.outOfStock = colors.red;

//FONTS
const font = {
  primary: 'dinot',
  secondary: 'nicky',
};

const weights = {
  ultra: 100,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
};

//TYPOGRAPHY
let typography = {
  fontFamily: font.primary,
  fontWeight: weights.normal,
  size: '14px',
  letterSpacing: '0',
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.5em',
    marginBottom: '1rem',
  },
  header: {
    fontFamily: font.primary,
    textTransform: 'none',
    fontWeight: weights.normal,
    letterSpacing: '0',
    secondColor: {
      color: colors.primary,
    },
  },
};

//HEADER ALT FONT
typography.header.secondFont = {
  fontFamily: font.secondary,
  fontWeight: weights.normal,
  textTransform: 'none',
  letterSpacing: typography.letterSpacing,
};
//HEADER FONTSIZES h1-h5 (sm & md & lg & xl)
typography.header.fontSize = [
  '__',
  [remCalc(26), remCalc(28), remCalc(31), remCalc(40)],
  [remCalc(20), remCalc(22), remCalc(24), remCalc(28)],
  [remCalc(16), remCalc(16), remCalc(18), remCalc(18)],
  [remCalc(14), remCalc(14), remCalc(14), remCalc(14)],
  [remCalc(12), remCalc(12), remCalc(12), remCalc(12)],
];

typography.header.secondFont.fontSize = [
  '__',
  [remCalc(50), remCalc(60), remCalc(80), remCalc(130)],
  [remCalc(40), remCalc(50), remCalc(60), remCalc(70)],
  [remCalc(36), remCalc(40), remCalc(42), remCalc(50)],
  [remCalc(30), remCalc(32), remCalc(36), remCalc(40)],
  [remCalc(26), remCalc(28), remCalc(30), remCalc(36)],
];

const general = {
  maxWidth: '1600px',
  maxWidthText: '1000px',
  pagePadding: {
    lg: '1rem',
    md: '1rem',
    sm: '1rem',
  },
  hallmarkBorder: '2px solid ' + colors.borderDark,
  radius: '3px',
  boxShadow: '0px 1px 2px #0000000d',
};

//BUTTON
const button = {
  background: colors.primary,
  backgroundSecondary: '#333',
  color: colors.white,
  colorSecondary: colors.white,
  fontFamily: font.primary,
  fontWeight: typography.header.fontWeight,
  fontSize: typography.header.fontSize[4],
  ListFontSize: typography.header.fontSize[5],
  textTransform: 'uppercase',
  letterSpacing: '1.5px',
};

//AREAS

//TOPBAR
const topBar = {
  height: {
    lg: 47,
    md: 40,
    sm: 40,
    scroll: 0,
  },
  color: colors.white,
  background: colors.primary,
  fontSize: '0.9rem',
  fontWeight: typography.fontWeight,
  usp: {
    fontSize: '0.9rem',
    fontWeight: typography.fontWeight,
  },
};

//DESKTOP HEADER
const desktopHeader = {
  height: {
    lg: 95,
    md: 70,
    scroll: 70,
  },
  search: {
    height: {
      lg: 30,
      md: 30,
    },
  },
  logo: {
    height: {
      lg: 50,
      md: 50,
      scroll: 50,
    },
  },
  background: colors.white,
  color: colors.font,
  nav: {
    padding: ['0.8rem', '1.1rem'],
    fontSize: [remCalc(16), remCalc(18)],
    nameTag: 'h3',
    fontWeight: weights.bold,
    barHoverColor: colors.buy,
    subMenu: {
      lv2: {
        fontSize: '1.1rem',
      },
      lv3: {
        fontSize: '0.9rem',
      },
    },
    height: {
      lg: 95,
      md: 70,
      scroll: 70,
    },
    useSubMenuImage: true,
  },
};

//MOBILE HEADER
const mobileHeader = {
  height: {
    xs: 60,
    sm: 60,
    scroll: 60,
  },
  search: {
    height: {
      xs: 60,
      sm: 60,
    },
  },
  logo: {
    height: 36,
  },
  background: colors.white,
  color: colors.font,
  nav: {
    padding: '2rem',
    lv1: {
      fontSize: remCalc(19),
      fontWeight: weights.bold,
      fontFamily: typography.header.fontFamily,
      lineHeight: '2.6em',
      textTransform: 'none',
    },
    lv2: {
      fontSize: '1rem',
      lineHeight: '3em',
    },
    lv3: {
      fontSize: '1rem',
      lineHeight: '2.6em',
    },
    lv4: {
      fontSize: '1rem',
      lineHeight: '1.6em',
    },
    activeColor: colors.primaryDark,
    selectedColor: colors.primary,
  },
};

//HEADER HEIGHTS
const header = {
  height: {
    lg: topBar.height.lg + desktopHeader.height.lg,
    md: topBar.height.md + desktopHeader.height.md,
    sm: topBar.height.md + mobileHeader.height.sm,
    xs: topBar.height.md + mobileHeader.height.xs,
    scroll: topBar.height.scroll + desktopHeader.height.scroll,
  },
  scrollBreak: 50,
};

//FOOTER
const footer = {
  background: colors.primary,
  color: colors.white,
  logoWrapper: {
    background: colors.primaryDark,
  },
};

//CAMPAIGN BAR
const campaignBar = {
  primary: {
    background: colors.backgroundLight,
    color: colors.font,
  },
  secondary: {
    background: colors.primaryLight,
    color: colors.white,
  },
};

//START PAGE
const startPage = {
  headers: {
    textTransform: 'none',
    fontFamily: font.primary,
    fontWeight: typography.header.fontWeight,
  },
  iconBar: {
    background: colors.primaryDark,
    color: colors.white,
  },
  textBox: {
    background: colors.primary,
    color: colors.white,
  },
  row: {
    background: {
      primary: colors.primaryDark,
      secondary: colors.primaryLight,
    },
    color: {
      primary: colors.font,
      secondary: colors.white,
    },
    noImage: {
      backgroundLight: colors.backgroundLight,
      backgroundDark: colors.backgroundDark,
    },
  },
  readMore: {
    color: colors.font,
    fontFamily: typography.header.fontFamily,
    fontWeight: typography.header.fontWeight,
  },
  cta: {
    fontSize: button.fontSize,
    color: colors.font,
    background: '#FFFFFFF2',
    border: 'none',
    fontFamily: button.fontFamily,
    fontWeight: button.fontWeight,
    textTransform: button.textTransform,
    letterSpacing: button.letterSpacing,
    hover: {
      color: colors.font,
      background: colors.primary,
      border: 'none',
    },
    secondary: {
      color: colors.font,
      background: colors.primary,
      border: 'none',
      hover: {
        color: colors.white,
        background: colors.primaryDark,
        border: 'none',
      },
    },
    third: {
      color: colors.font,
      background: 'transparent',
      border: '1px solid' + colors.font,
      hover: {
        color: colors.font,
        background: 'transparent',
        border: '1px solid' + colors.font,
      },
    },
  },
};

//CATEGORY PAGE
const categoryPage = {
  subcategories: {
    nameTag: 'h4',
    fontWeight: typography.header.fontWeight,
  },
  filter: {
    markerColor: colors.buy,
    hoverColor: colors.buy,
    desktop: {
      titles: {
        fontSize: button.fontSize,
        fontFamily: button.fontFamily,
        fontWeight: button.fontWeight,
        textTransform: button.textTransform,
        letterSpacing: typography.letterSpacing,
      },
    },
    drawer: {
      titles: {
        fontSize: button.fontSize,
        fontFamily: button.fontFamily,
        fontWeight: button.fontWeight,
        textTransform: button.textTransform,
        letterSpacing: typography.letterSpacing,
      },
    },
  },
};

//PRODUCT GRID
const productGrid = {
  pagination: false,
  col: {
    sm: 2,
    md: 3,
    lg: 4,
    xl: 4,
  },
  space: {
    sm: 3,
    md: 3,
    lg: 2,
    xl: 2,
  },
  product: {
    padding: {
      sm: '0',
      md: '0',
      lg: '0',
    },
    imageAspect: '10:15',
    background: '#FFF',
    border: 'none',
    name: {
      fontFamily: typography.header.fontFamily,
      fontWeight: typography.header.fontWeight,
    },
  },
};

const price = {
  fontFamily: typography.header.fontFamily,
  fontWeight: weights.medium,
  normal: {
    color: colors.font,
    fontSize: typography.header.fontSize[4],
  },
  new: {
    color: colors.discount,
    fontSize: typography.header.fontSize[4],
  },
  old: {
    color: colors.greys[5],
    fontSize: typography.header.fontSize[5],
    fontWeight: weights.normal,
  },
};

//PRODUCT PAGE
const productPage = {
  name: {
    fontWeight: productGrid.product.name.fontWeight,
  },
  price: {
    normal: {
      fontSize: typography.header.fontSize[2],
    },
    new: {
      fontSize: typography.header.fontSize[2],
    },
    old: {
      fontSize: typography.header.fontSize[3],
    },
  },
  imageAspect: '10:15',
  variantSelector: 'button', //dropdown || button
  buyButton: {
    background: colors.buy,
    color: colors.white,
  },
  tabs: {
    barActiveColor: colors.primary,
    header: {
      fontWeight: typography.header.fontWeight,
    },
  },
  productList: {
    headerColor: colors.font,
    subHeaderColor: colors.primary,
  },
};

export const theme = {
  ...cssMediaQueries,
  font,
  weights,
  typography,
  colors,
  general,
  button,
  topBar,
  desktopHeader,
  mobileHeader,
  header,
  footer,
  campaignBar,
  startPage,
  categoryPage,
  productGrid,
  price,
  productPage,
};
